var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgComputer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a27dbe18-ad67-4375-b09a-3831bed31179",
    "data-name": "Transparent Bounding Box (Export)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b109d87c-1953-46ca-b7f6-449bd5f26171",
    "data-name": "Icon Design (Export)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7,4H4A2,2,0,0,0,2,6V19a2,2,0,0,0,2,2H7a2,2,0,0,0,2-2V6A2,2,0,0,0,7,4ZM5.5,19A1.5,1.5,0,1,1,7,17.5,1.5,1.5,0,0,1,5.5,19ZM14,19h3v2H9.72A2,2,0,0,0,10,20V18h4ZM22,6v9a2,2,0,0,1-2,2H10V15H20V6H10V5a2,2,0,0,0-.28-1H20A2,2,0,0,1,22,6Z",
    fill: "#000001"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComputer);
export default __webpack_public_path__ + "static/media/computer.b5c7efe6c03ba12b8cf6170161d983c0.svg";
export { ForwardRef as ReactComponent };